module.exports = __webpack_public_path__ + "assets/img/logoScroll.12da0436.png";